<template>
  <div class="invoice card">
    <div class="card__balance">
    <swiper :options="swiperOption" @slideChange="onSlideChange" ref="mySwiper">
    <swiper-slide v-for="item in agreementsList" :key="item.id">
      <h5 class="personal-account">
        <template v-if="item.is_offer">
          <a v-if="item.agrm_link" :href="item.agrm_link" target="_blank" class="offerLink">
            <span>{{$t('Offer contract')}}</span>
            <i class="el-icon-link" style="margin-left: 8px; font-size: 16px"></i>
          </a>
          <span v-else>{{$t('Offer contract')}}</span>
        </template>
        <span v-else>{{ $t('Agreement') + ':' }} {{ item.number }}</span>
      </h5>
      <div class="invoice__value">
        <p class="balance">Баланс: {{ formatPrice(item.balance) + ' ' + item.currency}}</p>
        <p v-if="item.credit > 0" class="balance">Кредит: {{ formatPrice(item.credit) + ' ' + item.currency}}</p>
        <el-button
          v-if="paymentEnabled"
          plain
          type="primary"
          size="small"
          @click.native="paymentConfirm"
          class="pay-button">
            {{$t('Pay')}}
        </el-button>
      </div>
    </swiper-slide>
    <div v-if="agreementsList.length > 1" class="swiper-button-prev" slot="button-prev"></div>
    <div v-if="agreementsList.length > 1" class="swiper-button-next" slot="button-next"></div>
    </swiper>
    </div>
    <el-dialog
      custom-class="payment-modal"
      width="500px"
      destroy-on-close
      :visible.sync="modal.opened"
      v-on:open="onOpenModal"
      v-on:close="onCloseModal"
      :fullscreen="$mq === 'xs'"
      >
      <div slot='title'>
        <h4 class="title title-up">{{$t('Refill balance')}}</h4>
        <h6 class="subtitle">{{`Договор: ${this.payment.agreement.number}`}}</h6>
      </div>
      <div v-if="loadingRecommendedPayment" v-loading="loadingRecommendedPayment" class="loading-container"></div>
      <form ref="form" class="payment-form"  @submit.prevent="submitPayment" v-else>
        <el-form-item :label="$t('Provider')" v-if="providers.length > 1">
          <el-select name="provider-select" v-validate="validations.provider" class='provider-select' v-model="payment.provider">
            <el-option
              v-for="(provider, index) in providers"
              :key="index"
              class="select-default"
              :value="provider.slug"
              :label="provider.title || provider.slug">
            </el-option>
          </el-select>
        </el-form-item>
        <fg-input
          name="sum"
          :label="$t('Sum')"
          v-model="payment.sum"
          v-validate="'required|decimal:2|greaterThanZero'"
          @keypress="onlyForCurrency"
          @paste="onPaste"
          :error="getError('sum')"
        >
          <template v-slot:infoBlock>
            <div class="form-text recommended-payment">
              <span class="recommended-payment__title">{{`${$t('Recommended payment')}: `}}</span>
              <span @click="onClickRecommendedSum" v-bind:class="{ linqqqq: recommendedPaymentNotZero }">{{recommendedPaymentString}}</span>
            </div>
          </template>
        </fg-input>
        <fg-input
          name="email"
          type="email"
          :label="$t('Email')"
          v-validate="'required|email'"
          v-model="payment.email"
          :error="getError('email')"
        >
          <template v-slot:infoBlock>
            <span class="form-text">{{$t('Enter your E-Mail to receive an digital receipt')}}</span>
          </template>
        </fg-input>
        <el-switch
          v-if="payment.provider==='yookassa'"
          v-model="payment.isAutopayment"
          :active-text="$t('Create auto payment')"
          class="autopayment-switch"
          @change="onSetAutopayment"
        ></el-switch>
        <div v-if="payment.isAutopayment">
          <fg-input
            name="autopaymentSum"
            v-model="payment.autopaymentSum"
            :label="$t('Autopayment sum')"
            v-validate="'required|decimal:2|greaterThanZero'"
            :error="getError('autopaymentSum')"
          >
            <template v-slot:infoBlock>
              <div class="form-text recommended-payment">
                <span class="recommended-payment__title">{{`${$t('Amount of subscriptions')}: `}}</span>
                <span>{{`${subscriptionsSum} ${currentAgreement.currency}`}}</span>
              </div>
            </template>
          </fg-input>
          <div class="period-params">
            <fg-input
              name="dayOfMonth"
              :label="$t('Day of the month')"
              v-validate="'required|min_value:1|max_value:31'"
              v-model="payment.dayOfMonth"
              :error="getError('dayOfMonth')"
            >
            </fg-input>
            <fg-input
              name="period"
              :label="$t('Charge period in months')"
              v-validate="'required|min_value:1'"
              v-model="payment.period"
              :error="getError('period')"
            />
          </div>
          <div class="autopay-description" v-if="payment.sum > 0 && payment.autopaymentSum>0">
            <div>Мы проведём платёж на сумму {{ `${payment.sum} ${currentAgreement.currency}` }} и создадим автоплатёж.</div>
            <div>Первое списание на сумму {{ `${payment.autopaymentSum} ${currentAgreement.currency}` }} произойдёт {{ nextPaymentDate }}.</div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button
            plain
            class="payment-cancel-button"
            @click.native="modal.opened = false"
          >
            {{ $t('Cancel') }}
          </el-button>
          <el-button
            type="primary"
            nativeType="submit"
            :loading="loading"
          >
            {{ $t('Pay') }}
          </el-button>
        </div>
      </form>
    </el-dialog>
  </div>
</template>

<script>
// require styles
import 'swiper/dist/css/swiper.css'

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { format } from 'date-fns'
import { ru, az } from 'date-fns/locale'
import { FormGroupInput as FgInput } from '@/ui'
import { Button, Select, Option, Tag, Dialog, Switch } from 'element-ui'

import { mapState } from 'vuex'
import axios from 'axios'
import number from '../mixins/number'

export default {
  name: 'PersonalInvoice',
  mixins: [number],
  props: ['agreementsList'],
  components: {
    swiper,
    swiperSlide,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    'el-switch': Switch,
    [Tag.name]: Tag,
    [Dialog.name]: Dialog,
    FgInput
  },
  data () {
    return {
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      modal: {
        opened: false
      },
      payment: {
        agreement: {},
        email: '',
        sum: '',
        autopaymentSum: '',
        isAutopayment: false,
        dayOfMonth: 1,
        period: 1,
        provider: null
      },
      rules: {
        sum: [
          { required: true },
          { decimal: [2, '.'] }
        ],
        email: [
          { required: true, type: 'email', message: 'Please input email' }
        ]
      },
      recommendedPayment: '',
      subscriptionsSum: 0,
      loadingRecommendedPayment: true,
      loading: false,
      validations: {
        provider: {
          required: true
        },
        sum: {
          decimal: {
            decimals: true,
            separator: '.'
          }
        },
        email: {
          type: 'email'
        }
      }
    }
  },
  created() {
    this.$store.dispatch('getAllEpsProviders')
  },
  methods: {
    getError (fieldName) {
      return this.$t(this.errors.first(fieldName))
    },
    onOpenModal () {
      this.getRecommendedPayment()
    },
    onCloseModal () {
      this.payment.sum = ''
      this.payment.email = this.profile.email
      this.payment.isAutopayment = false
    },
    onPaste ($event) {
      $event.preventDefault()
      const value = $event.clipboardData.getData('text')
      if (!isNaN(value)) {
        this.payment.sum = Math.floor(value * 100) / 100
      }
    },
    onSetAutopayment(value) {
      if (value) {
        this.getSubscriptionsSum()
      }
    },
    getSubscriptionsSum () {
      axios.get('subscriptions', {
        params: {
          agrmid: this.payment.agreement.id,
          filterActive: true
        }
      }).then(promise => {
        this.subscriptions = promise.data.results
        if (promise.data.results.length) {
          const sum = this.subscriptions.reduce(function(a, b) {
            return a + b['monthly_cost']
          }, 0)
          this.subscriptionsSum = this.formatPrice(sum)
          this.payment.autopaymentSum = this.formatPrice(sum)
        }
        this.loading = false
      }).catch(error => {
        console.log(error)
        this.loading = false
      })
    },
    onlyForCurrency ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which)

      if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || this.payment.sum.indexOf('.') !== -1)) { // 46 is dot
        $event.preventDefault()
      }
      if (this.payment.sum != null && this.payment.sum.toString().indexOf('.') > -1 && (this.payment.sum.toString().split('.')[1].length > 1)) {
        $event.preventDefault()
      }
    },
    onSlideChange () {
      const index = this.$refs.mySwiper.swiper.activeIndex
      this.$emit('selectAgrm', index)
    },
    paymentConfirm () {
      this.modal.opened = true
      this.payment.email = this.profile.email
      this.payment.provider = this.providers.length > 0 ? this.providers[0].slug : null
      this.payment.agreement.id = this.currentAgreement.id
      this.payment.agreement.number = this.currentAgreement.number
    },
    getActiveProviders: function() {
      return axios.get('payment/enabled')
    },
    getRecommendedPayment: function() {
      this.loadingRecommendedPayment = true
      axios.get('recommendedPayment', {
        params: {
          agrmID: this.currentAgreement.id
        }
      }).then(promise => {
        this.recommendedPayment = promise.data.results
        if (promise.data.results > 0) this.payment.sum = promise.data.results
        this.loadingRecommendedPayment = false
      }).catch(error => {
        console.log(error.message)
        this.loadingRecommendedPayment = false
      })
    },
    onClickRecommendedSum: function() {
      if (this.recommendedPaymentNotZero) {
        this.payment.sum = this.recommendedPayment
      }
    },
    submitPayment: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const params = {
            sum: this.payment.sum,
            email: this.payment.email,
            agrmnum: this.payment.agreement.number,
            agrmid: this.payment.agreement.id,
            provider: this.payment.provider,
            returnUrl: window.location.origin + window.location.pathname
          }
          if (this.payment.isAutopayment) {
            params.isAutopayment = true
            params.dayOfMonth = this.payment.dayOfMonth
            params.period = this.payment.period
            params.autopaymentSum = this.payment.autopaymentSum
          }
          this.loading = true
          axios
            .post('payments/create', params)
            .then(promise => {
              window.location.replace(
                promise.data.results
              )
            })
            .catch(error => {
              this.loading = false
              console.log('error: ', error.response)
              var errorMessage = error.response.data.error
              this.$notify(
                {
                  message: errorMessage,
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger',
                  timeout: 1500
                })
            })
        }
      })
    }
  },
  computed: {
    ...mapState({
      config: state => state.config.data,
      providers: state => state.epsProviders.all,
      profile: state => state.profile.credentials,
      noContacts: state => !state.profile.credentials.email && !state.profile.credentials.mobile
    }),
    enabledProviders() {
      return this.providers ? this.providers : []
    },
    currentAgreement() {
      return this.agreementsList[this.$refs.mySwiper.swiper.activeIndex]
    },
    paymentEnabled: function() {
      if (this.profile.type === 1 && this.config.disableLegalEntityPayments) {
        return false
      }
      return this.providers.length > 0
    },
    recommendedPaymentNotZero: function() {
      return this.recommendedPayment > 0
    },
    recommendedPaymentString: function() {
      const currency = this.currentAgreement.currency
      return `${this.recommendedPayment} ${currency}`
    },
    nextPaymentDate: function() {
      const locale = this.$i18n.locale === 'az' ? az : ru
      var currentDate = new Date()
      var year = currentDate.getFullYear()
      var month = currentDate.getMonth()
      var currentDay = currentDate.getDate()
      const date = new Date(year, currentDay > this.payment.dayOfMonth ? month + 1 : month, this.payment.dayOfMonth)
      return format(date, 'd MMMM yyyy', { locale: locale })
    }
  }
}
</script>

<style type="scss">
.swiper-slide {
  text-align: center;
}
.balance {
  padding: 0;
  margin: 0 0 5px 0;
  line-height: 1;
  font-size: 18px;
}
.invoice__value {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.provider-select {
  width: 100%;
}
.payment-cancel-button{
  margin-right: 10px !important;
}
.personal-account {
  margin-bottom: 12px;
}
.invoice {
  padding-top: 30px;
  padding-bottom: 30px;
}
.el-button.pay-button {
  margin-top: 10px;
}
h6.subtitle {
  color: lightgray;
  text-align: center;
}
.payment-modal .el-dialog__body {
  padding-top: 0 !important;
  padding-bottom: 16px !important;
}
.payment-modal .el-dialog__footer {
  padding-top: 0 !important;
}
.payment-modal .title {
  margin: 0;
}
.payment-modal .el-dialog__header {
  text-align: center;
}
.dialog-footer button {
  margin-top: 20px;
  margin-bottom: 0;
}
.profile-link {
  text-decoration: underline;
}
.payment-error-tag {
  height: 38px !important;
  line-height: 36px !important;
  margin-right: auto !important;
}
.payment-error-tag > .el-icon-warning {
  font-size: 13px;
}
.provider-select,
.autopayment-switch {
  margin-top: 10px;
  margin-bottom: 10px;
}
.recommended-payment {
  display: flex !important;
  align-items: center !important;
  margin-top: 0.25rem;
  font-size: .9em;
}
.recommended-payment__title {
  margin-right: 0.2rem;
}
.linqqqq {
  text-decoration: underline;
  text-decoration-style: dashed;
  cursor: pointer;
}
.pay-date {
  font-style: italic;
}
.autopay-description {
  color: #9A9A9A;
  margin-bottom: 0;
}
.loading-container {
  height: 250px;
}
.period-params {
  display: flex;
  gap: 20px;
}
.period-params .form-group {
  flex: 1
}
.el-form-item__label {
  line-height: 1;
}
.payment-form .el-form-item__label{
  line-height: 1;
}
.offerLink,
.offerLink:visited {
  color: #55595c;
}
.offerLink:hover {
  color: #55595c;
  text-decoration: underline;
}
.offerLink .el-icon-link {
  color: #f96332;
}
</style>
